module.exports = __webpack_public_path__ + "img/sephora-logo.359ab4ef.png";